import styled, {css, DefaultTheme, FlattenSimpleInterpolation} from 'styled-components'

export const StyledInput = styled.input`
    ${({inputStyles}: {inputStyles?: (theme: DefaultTheme) => FlattenSimpleInterpolation}) => css`
        display: none;
        ${({theme}) => inputStyles && inputStyles(theme)};
    `}
`
